import { action, makeObservable, observable, runInAction } from 'mobx'
import { find } from 'lodash-es'
import { AssumptionCategoryBasic } from '@portal/pkg-api/gen/navigator'
import { AssumptionApi } from '@portal/pkg-api/navigator'

export class CategoryStore {
  public static STORE_NAME = 'categoryStore'

  @observable
  categories: AssumptionCategoryBasic[]

  constructor() {
    this.categories = []
    makeObservable(this)
  }

  @action
  async load() {
    const response = await AssumptionApi.getCategories()

    runInAction(() => {
      this.categories = response.data
    })
  }

  findById(id: number) {
    return find(this.categories, function (cat: AssumptionCategoryBasic) {
      return cat.id === id
    })
  }
}
